// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1GU0t{display:inline-block}._38A3m{fill:#66799d;height:16px;height:1.6rem;width:11px;width:1.1rem}html[dir=ltr] ._1lD1O,html[dir=rtl] ._38A3m{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}html[dir=ltr] ._1lD1O{margin-right:1.4rem}html[dir=rtl] ._1lD1O{margin-left:1.4rem;-webkit-transform:rotate(0);-ms-transform:rotate(0);transform:rotate(0)}", ""]);
// Exports
exports.locals = {
	"goToButton": "_1GU0t",
	"goToButton__arrow": "_38A3m",
	"goToButton__arrow--back": "_1lD1O"
};
module.exports = exports;
